// Bouton « + » de l'encart don (snippets/cart-donation.liquid) : ouvre la liste des autres
// montants. La liste partage name="id" avec les pastilles mais reste `disabled` tant qu'elle est
// fermée, pour que le formulaire n'envoie qu'un seul id. Chargé par sections/cart-drawer.liquid,
// hors de la zone re-rendue du tiroir.
if (!customElements.get('cart-donation-other')) {
  customElements.define(
    'cart-donation-other',
    class CartDonationOther extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.cart-donation__other-toggle');
        this.select = this.querySelector('select');
        this.radios = this.closest('form').querySelectorAll('input[type="radio"][name="id"]');

        this.toggle.addEventListener('click', () => this.#open());
        this.radios.forEach((radio) => radio.addEventListener('change', () => this.#close()));
      }

      #open() {
        this.radios.forEach((radio) => (radio.checked = false));
        this.select.disabled = false;
        this.toggleAttribute('open', true);
        this.toggle.setAttribute('aria-expanded', 'true');
        this.select.focus();
        // Ouvre directement la liste native ; ignoré là où showPicker() n'est pas supporté.
        try {
          this.select.showPicker();
        } catch {}
      }

      #close() {
        this.select.disabled = true;
        this.removeAttribute('open');
        this.toggle.setAttribute('aria-expanded', 'false');
      }
    }
  );
}
